<template>
	<div>
		<commonHeader />
		<div v-if="nowWidth > 784">
			<div class="notice_1">
				<v-img src="/image/notice_1.jpg" height="75vh" class="px-pc">
					<div class="about_1_text">
						Notice
					</div>
					<v-layout>
						<v-layout class="tab-css-2">
							<v-flex v-for="(tab, i) in $store.state.tabList" :key="i" class="pr-8" style="flex: 1; max-width: 20%;">
								<v-flex xs12>
									<v-divider dark class="main-hr-1 mb-4"></v-divider>
								</v-flex>
								<div>
									<div class="number mr-2">0{{ i + 1 }}</div>
									<div class="Title" @click="titleGoto(tab.link)">
										{{ tab.title }}
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-layout>
				</v-img>
			</div>
			<div class="px-pc notice_layout mt-16 pt-4">
				<div class="notice_section">
					<div class="notice_header_wrapper">
						<div class="notice_icon">
							<v-icon color="white" size="28">mdi-bullhorn-outline</v-icon>
						</div>
						<div class="notice_header_text">
							<h2 class="notice_title">공지사항</h2>
							<p class="notice_subtitle">세마인베스트먼트의 새로운 소식을 확인하세요</p>
						</div>
					</div>
				</div>
				<div class="notice_list">
					<v-simple-table class="notice_table">
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-center">번호</th>
									<th class="text-left">제목</th>
									<th class="text-center">등록일</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(notice, i) in sortedNotices" :key="notice.id" class="cursor" @click="openNotice(notice)">
									<td class="text-center">{{ sortedNotices.length - i }}</td>
									<td class="text-left">{{ notice.title }}</td>
									<td class="text-center">{{ notice.date }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
				<div class="divider_2_layout mb-2"></div>
			</div>
		</div>
		<div v-else>
			<div class="m_notice_1">
				<v-img width="100%" src="/image/notice_1.jpg" class="pl-6">
					<div class="m_about_1_text">
						Notice
					</div>
				</v-img>
			</div>
			<v-layout class="m_divider_1_layout">
				<hr class="m_divider_4" />
				<div class="m_notice_content">
					<div class="m_notice_header_wrapper">
						<div class="m_notice_icon">
							<v-icon color="white" size="20">mdi-bullhorn-outline</v-icon>
						</div>
						<div class="m_notice_header_text">
							<div class="m_notice_header">공지사항</div>
							<div class="m_notice_subtitle">새로운 소식을 확인하세요</div>
						</div>
					</div>
					<div class="m_notice_list">
						<v-card v-for="(notice, i) in sortedNotices" :key="notice.id" class="m_notice_card mb-4" @click="openNotice(notice)">
							<v-card-title class="m_notice_card_title">
								<span class="m_notice_number">{{ sortedNotices.length - i }}</span>
								<span class="m_notice_title_text">{{ notice.title }}</span>
							</v-card-title>
							<v-card-subtitle class="m_notice_card_subtitle">
								<span>{{ notice.date }}</span>
							</v-card-subtitle>
						</v-card>
					</div>
				</div>
			</v-layout>
		</div>
		<v-dialog v-model="selectNotice.dialog" :max-width="nowWidth > 784 ? '60%' : '90%'" content-class="dialog-notice">
			<v-card class="notice_dialog_card">
				<div class="dialog-header">
					<v-btn icon class="close-btn" @click="selectNotice.dialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
				<v-card-title class="notice_dialog_title">
					{{ selectNotice.title }}
				</v-card-title>
				<v-card-subtitle class="notice_dialog_date">
					{{ selectNotice.date }}
				</v-card-subtitle>
				<v-divider class="mx-4"></v-divider>
				<v-card-text class="notice_dialog_content">
					{{ selectNotice.content }}
				</v-card-text>
				<v-divider v-if="selectNotice.files && selectNotice.files.length > 0" class="mx-4"></v-divider>
				<v-card-actions v-if="selectNotice.files && selectNotice.files.length > 0" class="notice_dialog_actions">
					<div class="files_wrapper">
						<div class="files_title">
							<v-icon small color="iconColor1" class="mr-1">mdi-paperclip</v-icon>
							첨부파일
						</div>
						<div v-for="(file, index) in selectNotice.files" :key="index" class="file_item" @click="downloadFile(file.url)">
							<v-icon small color="iconColor1" class="mr-1">mdi-file-download</v-icon>
							{{ file.name }}
						</div>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<commonFooter />
	</div>
</template>
<script>
import { commonHeader, commonFooter } from '@/components/index'
import noticeData from '@/data/noticeData.json'

export default {
	name: 'notice',
	components: {
		commonHeader,
		commonFooter,
	},
	data() {
		return {
			screenWidth: window.innerWidth,
			notices: noticeData.notices,
			selectNotice: {
				dialog: false,
				id: null,
				title: '',
				content: '',
				files: [],
				date: '',
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
		sortedNotices() {
			return [...this.notices].sort((a, b) => new Date(b.date) - new Date(a.date))
		},
	},
	methods: {
		titleGoto(link) {
			this.$router.push({ name: link })
		},
		openNotice(notice) {
			this.selectNotice.dialog = true
			this.selectNotice.id = notice.id
			this.selectNotice.title = notice.title
			this.selectNotice.content = notice.content
			this.selectNotice.files = notice.files || []
			this.selectNotice.date = notice.date
		},
		downloadFile(url) {
			if (url) {
				window.open(url, '_blank')
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.dialog-header {
	display: flex;
	justify-content: flex-end;
	padding: 12px 8px 0 8px;
}
.close-btn {
	color: #999 !important;
	transition: all 0.2s ease;
	&:hover {
		color: #333 !important;
		background-color: #f5f5f5 !important;
		transform: rotate(90deg);
	}
}
.files_wrapper {
	width: 100%;
	padding: 16px 0 0 0;
}
.files_title {
	font-size: 13px;
	font-weight: 600;
	color: #666;
	margin-bottom: 14px;
	display: flex;
	align-items: center;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}
.file_item {
	padding: 14px 18px;
	margin-bottom: 10px;
	background: linear-gradient(135deg, #f8f9fc 0%, #eef1f6 100%);
	border-radius: 10px;
	cursor: pointer;
	font-size: 14px;
	color: #093981;
	display: flex;
	align-items: center;
	font-weight: 500;
	transition: all 0.2s ease;
	border: 1px solid transparent;
	&:hover {
		background: linear-gradient(135deg, #e8edff 0%, #dce3ff 100%);
		border-color: #093981;
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(9, 57, 129, 0.15);
	}
	&:last-child {
		margin-bottom: 0;
	}
}
</style>
